import React from "react";

import {
  Flex,
  FlexItem,
  Tooltip,
} from "@patternfly/react-core";

import { logosService } from "../services/logosService";
import { LOGO_SIZES } from "../../../../../../shared/constants/logoSizes";
import useAppearance from "shared/appearance/hooks/useAppearance";

const SchoolHeaderLogos = ({ variant = "desktop" }) => {
  const { colorScheme } = useAppearance();

  const logos = logosService.getLogos({
    variant,
    colorScheme,
  });

  return (
    <Flex
      alignItems={{ default: "alignItemsCenter" }}
      spaceItems={{ default: "spaceItemsMd" }}
      flexWrap={{ default: "nowrap" }}
    >
      {logos.map((logo) => {
        const image = (
          <img
            key={logo.id}
            src={logo.src}
            alt={logo.alt}
            loading="eager"
            style={{
              height: `${logo.height ?? LOGO_SIZES[variant][logo.size]}px`,
              width: "auto",
              display: "block",
              ...(logo.offset && {
                transform: `translate(${logo.offset.x}px, ${logo.offset.y}px)`,
              }),
            }}
          />
        );
        const wrappedImage = logo.tooltip ? (
          <Tooltip content={logo.tooltip}>
            {image}
          </Tooltip>
        ) : (
          image
        );

        return (
          <FlexItem key={logo.id}>
            {logo.href ? (
              <a
                href={logo.href}
                target={logo.external ? "_blank" : undefined}
                rel={logo.external ? "noopener noreferrer" : undefined}
                aria-label={logo.alt}
              >
                {wrappedImage}
              </a>
            ) : (
              wrappedImage
            )}
          </FlexItem>
        );
      })}
    </Flex>
  );
};

export default SchoolHeaderLogos;